import { render } from "./TeamTrial.vue?vue&type=template&id=4012354c"
import script from "./TeamTrial.vue?vue&type=script&lang=js"
export * from "./TeamTrial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__